import { updateLimitOrderSubmitStatus } from './../state/dex/actions'
import { CancelLimitOrderRequest } from '@tokenlon/v6-sdk'
import { useCallback } from 'react'
import { updateRefreshToken } from '~/state/application/reducer'
import { useAppDispatch } from '~/state/hooks'
import { LimitOrderItem } from './useUserLimitOrderList'
import { LimitOrderSubmitStatus } from '~/state/dex/type'
import { captureException } from '@sentry/nextjs'
import { useGA } from './useGA'
import { useAccount } from 'wagmi'
import { useV6SDK } from '~/hooks'
import {
  isUserRejectedError,
  TRACK_USER_REJECTED_MSG,
} from '~/utils/handleUserRejectedError'

export const useLimitOrderCancel = () => {
  const { address: account, chainId } = useAccount()
  const sdk = useV6SDK()
  const { trackClick } = useGA()
  const dispatch = useAppDispatch()
  return useCallback(
    async (order: LimitOrderItem) => {
      dispatch(
        updateLimitOrderSubmitStatus(LimitOrderSubmitStatus.CancelOrderPending),
      )
      try {
        const sig = await sdk.limitOrder.signCancelLimitOrder([order.orderHash])
        const cancelLimitOrderRequest: CancelLimitOrderRequest = {
          chainId,
          orderHashes: [order.orderHash],
          cancelSig: sig,
        }
        await sdk.limitOrder.cancelLimitOrder(cancelLimitOrderRequest)
        dispatch(updateRefreshToken(+new Date()))
        dispatch(
          updateLimitOrderSubmitStatus(
            LimitOrderSubmitStatus.CancelOrderSuccess,
          ),
        )
        trackClick('webtl_lo_active_cancel', { is_success: 1 })
      } catch (error) {
        console.error(error)

        const isUserRejected = isUserRejectedError(error)

        trackClick('webtl_lo_active_cancel', {
          is_success: 0,
          message: isUserRejected ? TRACK_USER_REJECTED_MSG : error?.message,
        })

        if (isUserRejected) {
          dispatch(
            updateLimitOrderSubmitStatus(
              LimitOrderSubmitStatus.CancelOrderRejected,
            ),
          )
        } else {
          dispatch(updateRefreshToken(+new Date()))
          if (error?.isAxiosError && error?.response?.data.code) {
            const status =
              LimitOrderSubmitStatus[
                'SignOrderFailureCode' + error.response.data.code
              ] || LimitOrderSubmitStatus.CancelOrderFailure
            dispatch(updateLimitOrderSubmitStatus(status))
          } else {
            dispatch(
              updateLimitOrderSubmitStatus(
                LimitOrderSubmitStatus.CancelOrderFailure,
              ),
            )
          }
          captureException(error)
        }
      }
    },
    [account, chainId],
  )
}
